
export default function Loader() {
	return (
		<div id="spinneroverlay">
			<div className="spinner"></div>
		</div>
	)
}
